// extracted by mini-css-extract-plugin
export default {"wrapper":"KzQ7dS","wrapper--with-border":"IGbfAK","wrapper-price":"HEFowJ","wrapper-checkbox":"HzWN6U"};